import { render, staticRenderFns } from "./FactModal.vue?vue&type=template&id=e068e9b6"
import script from "./FactModal.vue?vue&type=script&lang=js"
export * from "./FactModal.vue?vue&type=script&lang=js"
import style0 from "./FactModal.vue?vue&type=style&index=0&id=e068e9b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports